module.exports = __webpack_public_path__ + "img/pPoint.209090f8.svg";